// fix for chartjs, when hovering mouse over chart that was just updated
Object.defineProperty(Object.prototype, "_view", {
	enumerable: false,
	get() { return {skip: true}; },
	set(val: any) {
		Object.defineProperty(this, "_view", {value: val, writable: true, configurable: true});
	},
});